// ================ Action types ================ //

import api from '../api';
import { PROMOTION_TYPE } from '../constants/payment.constants';
import { storableError } from '../util/errors';
import { types as sdkTypes } from '../util/sdkLoader';

const { Money } = sdkTypes;

const FETCH_PROMOTION_REQUEST = 'app/promotions/FETCH_PROMOTION_REQUEST';
const FETCH_PROMOTION_SUCCESS = 'app/promotions/FETCH_PROMOTION_SUCCESS';
const FETCH_PROMOTION_ERROR = 'app/promotions/FETCH_PROMOTION_ERROR';

const FETCH_PROMOTION_PRICES_REQUEST = 'app/promotions/FETCH_PROMOTION_PRICES_REQUEST';
const FETCH_PROMOTION_PRICES_SUCCESS = 'app/promotions/FETCH_PROMOTION_PRICES_SUCCESS';
const FETCH_PROMOTION_PRICES_ERROR = 'app/promotions/FETCH_PROMOTION_PRICES_ERROR';

const PROMOTE_LISTING_REQUEST = 'app/promotions/PROMOTE_LISTING_REQUEST';
const PROMOTE_LISTING_SUCCESS = 'app/promotions/PROMOTE_LISTING_SUCCESS';
const PROMOTE_LISTING_ERROR = 'app/promotions/PROMOTE_LISTING_ERROR';

const PROMOTE_LISTINGS_BULK_REQUEST = 'app/promotions/PROMOTE_LISTINGS_BULK_REQUEST';
const PROMOTE_LISTINGS_BULK_SUCCESS = 'app/promotions/PROMOTE_LISTINGS_BULK_SUCCESS';
const PROMOTE_LISTINGS_BULK_ERROR = 'app/promotions/PROMOTE_LISTINGS_BULK_ERROR';

const CANCEL_LISTING_PROMOTION_REQUEST = 'app/promotions/CANCEL_LISTING_PROMOTION_REQUEST';
const CANCEL_LISTING_PROMOTION_SUCCESS = 'app/promotions/CANCEL_LISTING_PROMOTION_SUCCESS';
const CANCEL_LISTING_PROMOTION_ERROR = 'app/promotions/CANCEL_LISTING_PROMOTION_ERROR';

const RENEW_LISTING_PROMOTION_REQUEST = 'app/promotions/RENEW_LISTING_PROMOTION_REQUEST';
const RENEW_LISTING_PROMOTION_SUCCESS = 'app/promotions/RENEW_LISTING_PROMOTION_SUCCESS';
const RENEW_LISTING_PROMOTION_ERROR = 'app/promotions/RENEW_LISTING_PROMOTION_ERROR';

const BOOST_LISTING_REQUEST = 'app/promotions/BOOST_LISTING_REQUEST';
const BOOST_LISTING_SUCCESS = 'app/promotions/BOOST_LISTING_SUCCESS';
const BOOST_LISTING_ERROR = 'app/promotions/BOOST_LISTING_ERROR';
const CLEAR_BOOST_COMPLETED = 'app/promotions/CLEAR_BOOST_COMPLETED';

const TOGGLE_AD_BOOST_MODAL = 'app/promotions/TOGGLE_AD_BOOST_MODAL';
const TOGGLE_PROMOTION_MODAL = 'app/promotions/TOGGLE_PROMOTION_MODAL';
const TOGGLE_CANCEL_PROMOTION_MODAL = 'app/promotions/TOGGLE_CANCEL_PROMOTION_MODAL';
const TOGGLE_RENEW_PROMOTION_MODAL = 'app/promotions/TOGGLE_RENEW_PROMOTION_MODAL';

// ================ Reducer ================ //

const initialState = {
  promotion: null,
  fetchingPromotionInProgress: false,
  fetchingPromotionError: null,

  promotionPrices: null,
  promotionPricesInProgress: false,
  promotionPricesError: null,

  listingPromotionInProgress: false,
  listingPromotionError: null,

  cancelListingPromotionInProgress: false,
  cancelListingPromotionError: null,

  renewListingPromotionInProgress: false,
  renewListingPromotionError: null,

  boostListingInProgress: false,
  boostListingError: null,
  boostListingCompleted: false,

  listingsBulkPromotionError: null,
  listingsBulkPromotionInProgress: false,

  isOpenAdBoostModal: false,
  isOpenPromotionModal: false,
  isOpenCancelPromotionModal: false,
  isOpenRenewPromotionModal: false,
};

export default function promotionsReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_PROMOTION_REQUEST:
      return {
        ...state,
        promotion: null,
        fetchingPromotionError: null,
        fetchingPromotionInProgress: true,
      };
    case FETCH_PROMOTION_SUCCESS: {
      return {
        ...state,
        promotion: payload,
        fetchingPromotionInProgress: false,
      };
    }
    case FETCH_PROMOTION_ERROR:
      return {
        ...state,
        fetchingPromotionInProgress: false,
        fetchingPromotionError: payload,
      };

    case FETCH_PROMOTION_PRICES_REQUEST:
      return {
        ...state,
        promotionPricesInProgress: true,
        promotionPricesError: null,
      };
    case FETCH_PROMOTION_PRICES_SUCCESS:
      return {
        ...state,
        promotionPrices: payload,
        promotionPricesInProgress: false,
      };
    case FETCH_PROMOTION_PRICES_ERROR:
      return {
        ...state,
        promotionPricesError: payload,
        promotionPricesInProgress: false,
      };

    case PROMOTE_LISTING_REQUEST:
      return {
        ...state,
        listingPromotionError: null,
        listingPromotionInProgress: true,
      };
    case PROMOTE_LISTING_SUCCESS:
      return {
        ...state,
        listingPromotionInProgress: false,
        promotion: payload,
        isOpenPromotionModal: false,
      };
    case PROMOTE_LISTING_ERROR:
      return {
        ...state,
        listingPromotionInProgress: false,
        listingPromotionError: payload,
      };

    case PROMOTE_LISTINGS_BULK_REQUEST:
      return {
        ...state,
        listingsBulkPromotionError: null,
        listingsBulkPromotionInProgress: true,
      };

    case PROMOTE_LISTINGS_BULK_SUCCESS:
      return {
        ...state,
        listingsBulkPromotionInProgress: false,
      };

    case PROMOTE_LISTINGS_BULK_ERROR:
      return {
        ...state,
        listingsBulkPromotionError: payload,
        listingsBulkPromotionInProgress: false,
      };

    case CANCEL_LISTING_PROMOTION_REQUEST:
      return {
        ...state,
        cancelListingPromotionInProgress: true,
        cancelListingPromotionError: null,
      };
    case CANCEL_LISTING_PROMOTION_SUCCESS:
      return {
        ...state,
        cancelListingPromotionInProgress: false,
        isOpenCancelPromotionModal: false,
      };
    case CANCEL_LISTING_PROMOTION_ERROR:
      return {
        ...state,
        cancelListingPromotionInProgress: false,
        cancelListingPromotionError: payload,
      };

    case RENEW_LISTING_PROMOTION_REQUEST:
      return {
        ...state,
        renewListingPromotionInProgress: true,
        renewListingPromotionError: null,
      };
    case RENEW_LISTING_PROMOTION_SUCCESS:
      return {
        ...state,
        renewListingPromotionInProgress: false,
        isOpenRenewPromotionModal: false,
      };
    case RENEW_LISTING_PROMOTION_ERROR:
      return {
        ...state,
        renewListingPromotionInProgress: false,
        renewListingPromotionError: payload,
      };

    case BOOST_LISTING_REQUEST:
      return {
        ...state,
        boostListingInProgress: true,
        boostListingError: null,
        boostListingCompleted: false,
      };
    case BOOST_LISTING_SUCCESS:
      return {
        ...state,
        boostListingInProgress: false,
        isOpenAdBoostModal: false,
        boostListingCompleted: true,
      };
    case BOOST_LISTING_ERROR:
      return {
        ...state,
        boostListingInProgress: false,
        boostListingError: payload,
      };

    case CLEAR_BOOST_COMPLETED:
      return {
        ...state,
        boostListingCompleted: false,
      };

    case TOGGLE_AD_BOOST_MODAL:
      return {
        ...state,
        isOpenAdBoostModal: payload,
        boostListingError: null,
      };
    case TOGGLE_PROMOTION_MODAL:
      return {
        ...state,
        isOpenPromotionModal: payload,
        promoteListingError: null,
      };
    case TOGGLE_CANCEL_PROMOTION_MODAL:
      return {
        ...state,
        isOpenCancelPromotionModal: payload,
        cancelListingPromotionError: null,
      };
    case TOGGLE_RENEW_PROMOTION_MODAL:
      return {
        ...state,
        isOpenRenewPromotionModal: payload,
        renewListingPromotionError: null,
      };

    default:
      return state;
  }
}

export const fetchPromotionRequest = () => ({
  type: FETCH_PROMOTION_REQUEST,
});
export const fetchPromotionSuccess = promotion => ({
  type: FETCH_PROMOTION_SUCCESS,
  payload: promotion,
});
export const fetchPromotionError = e => ({
  type: FETCH_PROMOTION_ERROR,
  payload: e,
});

export const fetchPromotionPricesRequest = () => ({
  type: FETCH_PROMOTION_PRICES_REQUEST,
});
export const fetchPromotionPricesSuccess = prices => ({
  type: FETCH_PROMOTION_PRICES_SUCCESS,
  payload: prices,
});
export const fetchPromotionPricesError = e => ({
  type: FETCH_PROMOTION_PRICES_ERROR,
  error: true,
  payload: e,
});

export const promoteListingRequest = () => ({
  type: PROMOTE_LISTING_REQUEST,
});
export const promoteListingSuccess = promotion => ({
  type: PROMOTE_LISTING_SUCCESS,
  payload: promotion,
});
export const promoteListingError = e => ({
  type: PROMOTE_LISTING_ERROR,
  payload: e,
});

export const promoteListingsBulkRequest = () => ({
  type: PROMOTE_LISTINGS_BULK_REQUEST,
});
export const promoteListingsBulkSuccess = () => ({
  type: PROMOTE_LISTINGS_BULK_SUCCESS,
});
export const promoteListingsBulkError = e => ({
  type: PROMOTE_LISTINGS_BULK_ERROR,
  payload: e,
});

export const cancelListingPromotionRequest = () => ({
  type: CANCEL_LISTING_PROMOTION_REQUEST,
});
export const cancelListingPromotionSuccess = () => ({
  type: CANCEL_LISTING_PROMOTION_SUCCESS,
});
export const cancelListingPromotionError = () => ({
  type: CANCEL_LISTING_PROMOTION_ERROR,
});

export const renewListingPromotionRequest = () => ({
  type: RENEW_LISTING_PROMOTION_REQUEST,
});
export const renewListingPromotionSuccess = () => ({
  type: RENEW_LISTING_PROMOTION_SUCCESS,
});
export const renewListingPromotionError = () => ({
  type: RENEW_LISTING_PROMOTION_ERROR,
});

export const boostListingRequest = () => ({
  type: BOOST_LISTING_REQUEST,
});
export const boostListingSuccess = () => ({
  type: BOOST_LISTING_SUCCESS,
});
export const boostListingError = e => ({
  type: BOOST_LISTING_ERROR,
  error: true,
  payload: e,
});
export const clearBoostCompleted = () => ({
  type: CLEAR_BOOST_COMPLETED,
});

export const toggleAdBoostModal = isOpen => ({
  type: TOGGLE_AD_BOOST_MODAL,
  payload: isOpen,
});
export const toggleRenewPromotionModal = isOpen => ({
  type: TOGGLE_RENEW_PROMOTION_MODAL,
  payload: isOpen,
});
export const toggleCancelPromotionModal = isOpen => ({
  type: TOGGLE_CANCEL_PROMOTION_MODAL,
  payload: isOpen,
});
export const togglePromotionModal = isOpen => ({
  type: TOGGLE_PROMOTION_MODAL,
  payload: isOpen,
});

// ================ Thunks ================ //

export const fetchPromotion = listingId => dispatch => {
  dispatch(fetchPromotionRequest());

  return api.promotions
    .getDetails(listingId)
    .then(r => {
      dispatch(fetchPromotionSuccess(r?.data));
    })
    .catch(e => dispatch(fetchPromotionError(storableError(e))));
};

export const fetchPromotionPrices = () => dispatch => {
  dispatch(fetchPromotionPricesRequest());

  return api.promotions
    .getPrices()
    .then(r => {
      const prices = r?.data;
      const pricesObjects = Object.fromEntries(
        Object.entries(prices).map(([key, value]) => [key, new Money(value, 'EUR')])
      );
      dispatch(fetchPromotionPricesSuccess(pricesObjects));
    })
    .catch(e => dispatch(fetchPromotionPricesError(storableError(e))));
};

export const promoteListing = (listingId, plan, change = false) => dispatch => {
  dispatch(promoteListingRequest());

  const apiFn = change ? api.promotions.change : api.promotions.subscribe;

  return apiFn(listingId, plan)
    .then(response => {
      dispatch(promoteListingSuccess(response?.data?.promotion));
      dispatch(fetchPromotion(listingId));
      return response;
    })
    .catch(e => {
      dispatch(promoteListingError(storableError(e)));
      throw e;
    });
};
export const promoteListingsBulk = (listingIds, plan) => dispatch => {
  dispatch(promoteListingsBulkRequest());

  return api.promotions
    .subscribeBulk(listingIds, plan)
    .then(response => {
      dispatch(promoteListingsBulkSuccess(response?.data?.processedListings));
      return response;
    })
    .catch(e => {
      dispatch(promoteListingsBulkError(storableError(e)));
      throw e;
    });
};

export const boostListing = listingId => dispatch => {
  dispatch(boostListingRequest());

  return api.promotions
    .subscribe(listingId, PROMOTION_TYPE.ONE_TIME.AD_BOOST)
    .then(response => {
      dispatch(boostListingSuccess(response?.data?.promotion));
      dispatch(fetchPromotion(listingId));
      return response;
    })
    .catch(e => {
      dispatch(boostListingError(storableError(e)));
      throw e;
    });
};

export const cancelListingPromotion = listingId => dispatch => {
  dispatch(cancelListingPromotionRequest());

  return api.promotions
    .unsubscribe(listingId)
    .then(() => {
      dispatch(cancelListingPromotionSuccess());
      dispatch(fetchPromotion(listingId));
    })
    .catch(e => {
      dispatch(cancelListingPromotionError(storableError(e)));
    });
};

export const renewListingPromotion = listingId => dispatch => {
  dispatch(renewListingPromotionRequest());

  return api.promotions
    .renew(listingId)
    .then(() => {
      dispatch(renewListingPromotionSuccess());
      dispatch(fetchPromotion(listingId));
    })
    .catch(e => {
      dispatch(renewListingPromotionError(storableError(e)));
    });
};
